// Recovery is a one-time escape hatch from stale editor UI state, not a
// permanent route. Keeping ?recover=1 in a bookmark would force Projects on
// every refresh, even after the user returns to Refine.
export const workspaceRecoveryRequested=search=>new URLSearchParams(search).get('recover')==='1';

export function consumeWorkspaceRecovery(location,history){
 const url=new URL(location.href);
 if(!workspaceRecoveryRequested(url.search))return false;
 url.searchParams.delete('recover');
 // Keep billing, sign-in, feedback and other unrelated navigation parameters.
 // Preserve existing history.state instead of overwriting router state.
 history.replaceState(history.state,'',url.pathname+url.search+url.hash);
 return true;
}
